import React, { useEffect, useMemo, useState } from 'react';
import targetIcon from '../../assets/icons/ic_target.svg';
import IconTint from 'react-icon-tint';
import { useAtom } from 'jotai';
import { savedSelectedLoc } from '../store/DataStore';
import LocationSelectionGrid from '../LocationSelectionGrid';
import ModalShell from './ModalShell';
import { getVisibleLocationOrDefault, getVisibleLocations } from './locationVisibility';

const GotoPopup = ({ isOpen, children, onClose, onSend, locations }) => {
    const [show, setShow] = useState(isOpen);
    const [selectedLocation, setSelectedLocation] = useAtom(savedSelectedLoc);
    const visibleLocations = useMemo(() => getVisibleLocations(locations), [locations]);
    const canSend = visibleLocations.includes(selectedLocation);

    useEffect(() => {
        if (isOpen) {
            setShow(true);
            const visibleSelection = getVisibleLocationOrDefault(selectedLocation, visibleLocations);
            if (visibleSelection !== selectedLocation) {
                setSelectedLocation(visibleSelection);
            }
        } else {
            setShow(false);
            setTimeout(onClose, 200);
        }
    }, [isOpen, onClose, selectedLocation, setSelectedLocation, visibleLocations]);

    const handleClose = () => {
        setShow(false);
        setTimeout(onClose, 200);
    };

    const handleSend = () => {
        onSend();
        setShow(false);
        setTimeout(onClose, 200);
    }

    return (
        <ModalShell isMounted={show || isOpen} isOpen={show} onClose={handleClose} maxWidth="md">
            <div className="-mt-2 flex flex-col items-center text-center">
                {children}
            </div>
            <LocationSelectionGrid
                className="mt-6"
                locations={visibleLocations}
                selectedLocation={selectedLocation}
                onSelect={setSelectedLocation}
                columnsClass="grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
                buttonClassName="w-full min-w-0"
                emptyMessage="No destinations available"
            />
            <div className='mt-8 flex justify-center'>
                {canSend ?
                    <button
                        type="button"
                        className='flex w-full items-center justify-center rounded-3xl bg-[#152FF5] px-5 py-2 text-white sm:w-auto'
                        onClick={handleSend}
                    >
                        <span className='font-heebo'>Send Zeeno</span>
                        <IconTint src={targetIcon} className='ml-2 h-5' color='#FFFFFF' />
                    </button>
                    :
                    <div className='flex w-full items-center justify-center rounded-3xl bg-[#152FF5] px-5 py-2 opacity-50 sm:w-auto'>
                        <span className='font-heebo text-white'>Send Zeeno</span>
                        <IconTint src={targetIcon} className='ml-2 h-5' color='#FFFFFF' />
                    </div>
                }
            </div>
        </ModalShell>
    );
};

export default GotoPopup;
